import { InformativeModal } from "../../../components/modal/Modal";
import type { VoidComponent } from "solid-js";
import { getOwner, runWithOwner } from "solid-js";
import { useTranslation } from "../../../state/i18n";
import NavigationService from "../../../services/NavigationService";

type SaveNotAllowedModalProps = {
  title: string;
  description: string;
};

const SaveNotAllowedModal: VoidComponent<SaveNotAllowedModalProps> = (props) => {
  const owner = getOwner();
  const { t } = useTranslation();

  return (
    <InformativeModal
      confirmLabel={t(($) => $.FORM_EDITOR_SAVE_NOT_ALLOWED_BUTTON)}
      closeAriaLabel={t(($) => $.CLOSE_ARIA)}
      title={props.title}
      description={props.description}
      onConfirm={() => {
        runWithOwner(owner, () => {
          NavigationService.exitFormEditor();
        });
      }}
    />
  );
};

export default SaveNotAllowedModal;
